<app-back-button *ngIf="showBackButton" [label]="flowLabel" variant="checkout" (backClick)="goBack()"></app-back-button>

<div class="checkout-wrapper" [class.checkout-wrapper--with-steps]="showStepper && !isCheckoutLoading">
  <app-onboarding-stepper
    *ngIf="showStepper && !isCheckoutLoading"
    class="checkout-wrapper__steps"
    current="payment"
    [includePayment]="true"
  ></app-onboarding-stepper>

  <div class="checkout-wrapper__payment" [class.checkout-wrapper__payment--loading]="isCheckoutLoading">
    <div class="checkout-wrapper__spinner" *ngIf="isCheckoutLoading">
      <div class="app-spinner"></div>
    </div>
    <div id="payment-element"></div>
  </div>
</div>
